import React from "react";

export const DKDTnc = ({ handleModalClick }) => {
  return (
    <div>
      <div className="TnCcontainer">
        <div className="modalheader">
          <h1>Terms and Conditions of DishTV VZY OTT Carnival Offer</h1>
          <span className="copenModal cmodalclose" onClick={handleModalClick}>
            <span></span>
          </span>
        </div>

        <section className="content-section">
          <p>
            The present terms and conditions (“T&C”) are applicable for the
            DishTV VZY OTT Carnival Offer (“Offer”) of Dish Infra Services
            Private Limited (Company) and is valid across India except the state
            of Tamil Nadu and states where specifically prohibited by law.
          </p>
          <br />
          <p>
            This Offer is for the OTT subscribers of the Company’s OTT VZY
            subscription plans. Participation in the Offer is subject to the
            applicable terms and conditions stated herein. By participating in
            this Offer, subscriber agrees to all terms and conditions of this
            Offer. Subscribers must check with detail terms and conditions
            before participating in the Offer.
          </p>
        </section>

        <section className="offer-period">
          <p> Offer Period - 9th October 2024 – 21st November 2024</p>
        </section>

        <section className="offer-details">
          <h2 className="underlinetext">Offer</h2>
          <ul>
            <li>
              <p>
                Offer is available to (i) for all new user of VZY who avails VZY
                subscription plans by successful registration during the Offer
                Period ; (ii) VZY de-active subscribers of 7 days and more and
                avails a VZY subscription plan during the Offer Period and (iii)
                VZY subscribers renewing their VZY subscription plans during the
                Offer Period(“Eligible Subscriber”).
              </p>
            </li>
            <li>
              <p>All Eligible Subscribers will receive:</p>
              <ul>
                <li>
                  If registering through vzy Website{" "}
                  <a href="https://www.vzy.one">www.vzy.one</a> or through the
                  vzy app: 30 days of the VZY plan opted at no extra cost.
                </li>
                <li>
                  If registering through specific link provided by the Company:
                  fifteen days trial offer of VZY subscription plans (as
                  applicable).
                </li>
              </ul>
            </li>
            <li>
              <p>
                All Eligible Subscribers with the VZY App downloaded in their
                devices shall be considered for one Bumper Lucky Draw conducted
                at the end of the Offer Period as per the schedule stated herein
                in this T&C.
              </p>
            </li>
            <li>
              <p>
                The mobile number given by the Eligible Subscriber at the time
                of registration shall be considered as final for the purpose of
                the Offer.
              </p>
            </li>
          </ul>
        </section>

        <section className="draw-terms">
          <h3>
            Terms & Conditions for Bumper Lucky Draw <br />
            Prizes to Be Won:
          </h3>
          <table>
            <thead>
              <tr>
                <th>Bumper Draw</th>
                <th>Date of Announcement</th>
                <th>Total Prizes</th>
                <th>Number of Winners</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td></td>
                <td>21st November 2024</td>
                <td style={{ width: "120%" }}>
                  <p>
                    1 Car Hatchback - Tata Tiago
                    <br />
                    1 Bike – Pulsar
                    <br />
                    1 iPhone
                    <br />
                    1 TV 55” inches
                    <br />
                    1 Split AC (Capacity-1.5 Ton)
                    <br />1 Laptop
                  </p>
                </td>
                <td>6</td>
              </tr>
            </tbody>
          </table>
          <ul>
            <li>
              <p>
                Brands and color preferences of the prizes under the Offer shall
                be at the discretion of the Company unless specifically stated.
              </p>
            </li>
            <li>
              <p>
                The Company and its officers shall not be responsible in any
                manner whatsoever for the manufacturing quality, warranty,
                performance, after-sale service, suitability of the prizes, or
                for any loss, damage, theft, breakage, malfunction, or any
                defect caused to or noticed in respect of the prizes.
              </p>
            </li>
            <li>
              <p>
                All taxes, levies, and duties due and owing under applicable and
                statutory laws in connection with all the winnings or to claim
                the prizes are the sole responsibility of the Winner.
              </p>
            </li>
            <li>
              <p>
                The Company shall be liable to pay only the ex-showroom
                price/on-road price of the Car/Bike, and all applicable taxes
                including but not limited to income tax, TDS, gift tax, road
                tax, registration, and insurance charges for the Car and any
                other statutory levy as may be applicable from time to time in
                relation to the Car will be payable by the Winner. The winner
                shall be solely responsible for any other expense for claiming
                the prize. The Company or its associates shall not be liable or
                responsible for the same in any manner.
              </p>
            </li>
            <li>
              <p>
                The Company shall not be responsible for the delivery or
                installation of the prizes won by the winners.
              </p>
            </li>
          </ul>
        </section>

        <section className="draw-terms">
          <h3>Procedure of Selection of Lucky Draw Winners</h3>
          <ul>
            <li>
              <p>
                Selection of winners of Bumper Lucky Draws will be on a random
                basis. The Winners shall be determined from all the Eligible
                Subscribers by a Randomization Method - computer-generated
                random selections, and the results announced shall be final and
                binding. No correspondence shall be entertained in this regard.
              </p>
            </li>
            <li>
              <p>
                Winners of the Bumper Lucky Draw will be selected on a random
                basis by a computerized process, and the name of winners will be
                announced any time during the day on 21st November 2024.
              </p>
            </li>
          </ul>
        </section>

        <section className="contact">
          <h3>How Winners Will Be Announced / Contacted</h3>
          <ul>
            <li>
              <p>
                The name of the Winners of Bumper Lucky Draw will be published
                on the official websites of the Company. Winners will also be
                contacted by the Company on the Registered Mobile Number of the
                Winner only to communicate necessary steps/instructions for
                claiming the Prize and or making necessary payment towards taxes
                and charges, if any for collecting the Prizes.
              </p>
            </li>
            <li>
              <p>
                In case the Winner does not receive the communication, which has
                been validly sent by the Company, for any reason whatsoever,
                including but not limited to the fact that the phone
                number/address/email address is not correct as per the details
                with the Company or if the winner does not respond or contact
                the Company, the Company shall not be liable to give the Prize
                to the Winner and the same may stand forfeited. Once forfeited,
                the winner shall not be eligible for the prize.
              </p>
            </li>
            <li>
              <p>
                Mere participation in the Offer does not entitle to win the
                Prizes.
              </p>
            </li>
          </ul>
        </section>

        <section className="redemption">
          <h3>Prize Redemption / Delivery / Taxation Liability</h3>
          <ul>
            <li>
              <p>
                The winner of the Lucky Draws shall be responsible for the
                collection of the Prizes or to take delivery of the prizes upon
                furnishing documents (valid government ID - Aadhar Card, PAN
                Card, Passport) and for payment of applicable taxes as
                instructed by the Company. The Company reserves the right to
                disqualify/forfeit a winner if satisfactory documents are not
                furnished or applicable taxes are not paid by a winner. Winners
                will be required to share other documents to the Company to
                ascertain identity or otherwise.
              </p>
            </li>
            <li>
              <p>
                Winners must collect their prizes from the location specified in
                the communication from the Company. The Winner shall be solely
                responsible for ensuring that they have valid driving documents
                and other documents as may be required for the registration of
                any prize which is a vehicle in the name of the winner.
              </p>
            </li>
            <li>
              <p>
                Failure to avail / collect the Prizes within the timelines given
                by the Company while intimating the Winner about his winning the
                Prize would result in the Prize being declared null and void and
                no Prize shall be awarded by the Company after the expiry of the
                timeline communicated for collecting the Prize.
              </p>
            </li>
            <li>
              <p>
                Prizes cannot be redeemed for cash or in any other form. No cash
                payment shall be made to the Winners in lieu of Offer Prizes.
                Collection of prizes shall be the sole responsibility of the
                winners including postal/ courier charges, travel expenses to
                the location for collection of prizes.
              </p>
            </li>
            <li>
              <p>
                The Prizes to Winners shall be given subject to compliance with
                all applicable statutory legislations/processes/formalities in
                connection with the Prize and on production of all such
                documents/papers as required by the Company before accepting the
                delivery of the Prize. Any failure on the part of the winner to
                comply with directions issued by Company for claim of Prize
                shall entitle the Company to forfeit the Prize.
              </p>
            </li>
            <li>
              <p>
                In the event of a death of the Winner, no claim from the
                nominees or legal heirs of the Winner shall be entertained by
                the Company for receiving the prizes.
              </p>
            </li>
          </ul>
        </section>
        <section className="redemption">
          <h3>FINALITY OF DECISION</h3>
          <ul>
            <li>
              <p>
                Decision of the Company shall be final and binding regarding
                this Offer, Prize and parameter to decide the Winner. The
                winners decided by the Company for this Offer will be final and
                binding on all subscribers and winners.
              </p>
            </li>
            <li>
              <p>
                The Company, reserves the right to extend, cancel, discontinue,
                withdraw, change, alter or modify the terms of the Offer at its
                sole discretion without any notice at any time during the Offer
                Period with or without notification and without assigning any
                reason.
              </p>
            </li>
            <li>
              <p>
                Company shall not be responsible for any loss or damage, if it
                has to alter, modify or withdraw this Offer in compliance with
                any law, ruling, order, regulation, requirement or instruction
                of any Central/State Government, or any other unavoidable reason
                beyond their control.
              </p>
            </li>
            <li>
              <p>
                In the event of any fault, misunderstanding or dispute
                concerning any part of the Offer, the decision of Company shall
                be final.
              </p>
            </li>
          </ul>
        </section>
        <section className="legal">
          <h3>Miscellaneous</h3>
          <ul>
            <li>
              <p>The Offer is subject to force majeure conditions.</p>
            </li>
            <li>
              <p>
                Subscribers expressly gives his consent to Dish TV India limited
                to be contacted for marketing and promotional activities. Each
                winner agrees that his/her name, address, telephone numbers,
                e-mail identities or any other information that is provided by
                the winner (“Personal Information”) including images may be
                shared by the Company with others associated with and/or
                assisting in organizing and administering the Contest, and for
                use by the Company.
              </p>
            </li>
            <li>
              <p>
                Subscriber’s data - Dish TV India Limited may collect personal
                information from Subscribers for administration purposes and
                will handle personal information in accordance with its privacy
                policy. Subscribers hereby consent to the processing of its
                personal data provided under the terms and conditions of this
                Offer as per the privacy policy.
              </p>
            </li>
            <li>
              <p>
                This Offer is open for residents of India only. However,
                residents of the state of Tamil Nadu and wherever prohibited,
                shall not be entitled to participate in the Offer. The Offer
                shall be subject to all applicable mandatory national and state
                laws.
              </p>
            </li>
            <li>
              <p>
                This Offer is in no way sponsored, endorsed or administered by,
                or associated with the brands the product of which form part of
                the prizes under the Offer and of any media including social
                media on which the Offer will or may be communicated by the
                Company. The names or images used in the Offer belongs to the
                respective brands owners.
              </p>
            </li>
            <li>
              <p>
                Company does not make any commitment, express or implied, to
                respond to any feedback, suggestion and, or, queries of the
                participants or furnish any reason or explanation for inclusion
                and/or exclusion of any particular submission of the entry of a
                participants at any stage of the Offer.
              </p>
            </li>
            <li>
              <p>
                These terms and conditions shall be governed by and construed in
                accordance with the laws of India. All disputes are subject to
                the jurisdiction of Delhi courts.
              </p>
            </li>
            <li>
              <p>
                The Company is free to reproduce, use, disclose and distribute
                any information / details of this scheme to third parties
                without limitation. The company reserves the right to publish
                the photograph and / or name of the winner in promotional
                materials and advertisements as it deems fit.
              </p>
            </li>
            <li>
              <p>
                This document is an electronic record in terms of Information
                Technology Act, 2000 and the Rules thereunder as applicable and
                the amended provisions pertaining to electronic records in
                various statutes as amended by the Information Technology Act,
                2000.
              </p>
            </li>
            <li>
              <p>
                This electronic record is generated by a computer system and
                does not require any physical or digital signatures.
              </p>
            </li>
          </ul>
          <p style={{ textAlign: "center" }}>
            ***************************************************************
          </p>
        </section>
      </div>
    </div>
  );
};
